import moment from 'moment';

export function getDuration(timeReported){
    let now = moment.utc();
    let rep = moment.utc(timeReported);
    let elapsed = (now.valueOf() - rep.valueOf()).toString();
    let minutes = Math.floor(elapsed/1000/60);
    if(elapsed < 60000) return 0;
    return minutes;
}